module.exports = __webpack_public_path__ + "img/training-travel5.68673df2.jpg";